import ProfileDetail from './ProfileDetail'
import styles from './styles.css'

export {
    ProfileDetail,
    styles
}